import { render } from "./InfiniteList.vue?vue&type=template&id=6f124b4c&scoped=true"
import script from "./InfiniteList.vue?vue&type=script&lang=ts"
export * from "./InfiniteList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6f124b4c"

export default script